export const defaultFilters = {
    // premiumFilters: {
    //     imports: [],
    // },
    // advancedFilters: {
    assetClasses: [],
    exchanges: ['AMEX', 'NASDAQ', 'NYSE'],
    identifierCodes: {
        sic: '',
        cusip: '',
        lei: '',
        cei: '',
        isin: '',
        figi: '',
    },
    industries: [],
    sectors: [],
    location: {
        country: '',
        stateTerritory: '',
        city: '',
        zipCode: '',
    },
    fundamentals: {
        annualRevenue: [],
    },
    fiscalYearEnd: [],
    employeeHeadcount: [],
    institutionalOwnership: {
        min: 0,
        max: 100,
    },
    attributes: [],
    esg: {
        environmental: {
            min: 0,
            max: 100,
        },
        social: {
            min: 0,
            max: 100,
        },
        governance: {
            min: 0,
            max: 100,
        },
    },
    technologies: {
        entireCategories: [],
        individualTechnologies: [],
    },
    webTraffic: [],
    fundraising: [],
    // },
    // eventFilters: {
    //     news: {
    //         toggled: true,
    //         categories: ['Mainstream', 'Press Releases', 'Currencies', 'Cryptocurrencies'],
    //     },
    //     insiderTransactions: {
    //         toggled: true,
    //         categories: [],
    //     },
    //     ipos: {
    //         toggled: true,
    //         startDate: sd,
    //         endDate: ed,
    //     },
    //     mAndA: {
    //         toggled: true,
    //     },
    // },
};
